// vendorService.js
// API service for vendor management

import { HTTPService } from './httpService';

const API = new HTTPService();

// ============================================================================
// Vendors
// ============================================================================

export const getVendors = async (installerId) => {
    const { data } = await API.get('/api/vendors', { installerId });
    return data.data || data;
};

export const getVendor = async (vendorId) => {
    const { data } = await API.get(`/api/vendors/${vendorId}`);
    return data.data || data;
};

export const createVendor = async (vendorData) => {
    const { data } = await API.post('/api/vendors', vendorData);
    return data;
};

export const updateVendor = async (vendorId, vendorData) => {
    const { data } = await API.patch(`/api/vendors/${vendorId}`, vendorData);
    return data;
};

export const deleteVendor = async (vendorId) => {
    const { data } = await API.delete(`/api/vendors/${vendorId}`);
    return data;
};

// ============================================================================
// Vendor Products
// ============================================================================

export const getVendorProducts = async (vendorId) => {
    const { data } = await API.get(`/api/vendors/${vendorId}/products`);
    return data.data || data;
};

export const addVendorProduct = async (vendorId, productData) => {
    const { data } = await API.post(`/api/vendors/${vendorId}/products`, productData);
    return data;
};

export const updateVendorProduct = async (vendorProductId, productData) => {
    const { data } = await API.patch(`/api/vendor-products/${vendorProductId}`, productData);
    return data;
};

export const deleteVendorProduct = async (vendorProductId) => {
    const { data } = await API.delete(`/api/vendor-products/${vendorProductId}`);
    return data;
};

// ============================================================================
// Product Vendors (reverse lookup)
// ============================================================================

export const getProductVendors = async (productId) => {
    const { data } = await API.get(`/api/products/${productId}/vendors`);
    return data.data || data;
};

// Default export for convenience
const VendorAPI = {
    getVendors,
    getVendor,
    createVendor,
    updateVendor,
    deleteVendor,
    getVendorProducts,
    addVendorProduct,
    updateVendorProduct,
    deleteVendorProduct,
    getProductVendors
};

export default VendorAPI;
